import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
  Zoom,
} from "@mui/material";
import { pink } from "@mui/material/colors";
import { useEffect, useState } from "react";
import Create from "./Create";
import partialDelete from "./PartialDelete";

function Drafts(props) {
  const { setMain } = props;

  const [messages, setMessages] = useState([]);

  const draftMessages = messages.filter((msg) => {
    return msg.label === "drafts" && msg.deleted === false ? true : false;
  });

  useEffect(()=>{getMessages()}, []);

  const handleResend = (text) => {
    setMain(<Create text={text} />);
  };

  const handleDelete = (id) => {
    const filteredMessages = messages.map((mesg) => {
      if (id === mesg.id) {
        mesg.deleted = true;
      }
      return mesg;
    });
    setMessages(filteredMessages);
    const params = {
      url: "http://127.0.0.1:8000/messenger/messages/",
      method: "PATCH",
      params: {
        id: id,
        type: "delete",
      },
    };
    const results = partialDelete(params);
  };

  async function getMessages() {
    const response = await fetch("http://127.0.0.1:8000/messenger/messages/", {
      mode: "cors",
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    const fetcher = response.body.getReader();
    let data = [];
    let receivedLength = 0;
    while (true) {
      const { value, done } = await fetcher.read();

      if (done) {
        break;
      }

      data.push(value);
      receivedLength += value.length;
    }
    let chunksAll = new Uint8Array(receivedLength);
    let position = 0;
    for (let chunk of data) {
      chunksAll.set(chunk, position);
      position += chunk.length;
    }
    let result = new TextDecoder("utf-8").decode(chunksAll);

    let finalData = JSON.parse(result);
    setMessages(finalData);
  }
  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack>
      <Typography variant="h6">Drafts</Typography>
      <Divider variant="middle" />
      {draftMessages.length>0 ? draftMessages.map((message) => {
        return (
          <Card elevation={3} key={message.id} sx={{ mt: 1, mb: 1 }}>
            <CardHeader
              sx={{ bgcolor: pink[500] }}
              avatar={<Avatar>D</Avatar>}
              title={message.date}
            />
            <CardContent>
              <Typography>{message.message}</Typography>
            </CardContent>
            <CardActions
              sx={{ display: "flex", justifyContent: "space-evenly" }}
            >
              <Button
                variant="outlined"
                onClick={() => handleResend(message.message)}
              >
                Edit
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={() => handleDelete(message.id)}
              >
                Delete
              </Button>
            </CardActions>
          </Card>
        );
      }) : <Box display={'flex'} justifyContent={'center'} mt={2}><Typography>No Drafts</Typography></Box>}
      </Stack>
    </Zoom>
  );
}

export default Drafts;
